import { initializeApp } from "firebase/app";
import { getStorage, ref, getDownloadURL } from "firebase/storage";
import { 
  getAuth, 
  createUserWithEmailAndPassword, 
  signInWithEmailAndPassword, 
  signOut,
  signInWithCustomToken,
  onAuthStateChanged,
  sendPasswordResetEmail
} from "firebase/auth";
import { getFirestore, doc, setDoc, getDoc, updateDoc } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyAkCVQ17OLaOKoo7a8LFHWyqxgUQHcsNhI",
  authDomain: "yogaapp-7dd5d.firebaseapp.com",
  projectId: "yogaapp-7dd5d",
  storageBucket: "yogaapp-7dd5d.appspot.com",
  messagingSenderId: "695947644424",
  appId: "1:695947644424:web:b7edbd7e9d0d720124cbbd",
  measurementId: "G-VFXR14FRSQ"
};

const app = initializeApp(firebaseConfig);
const storage = getStorage(app);
const auth = getAuth(app);
const firestore = getFirestore(app);

export {
  auth,
  createUserWithEmailAndPassword,
  signInWithEmailAndPassword,
  signOut,
  signInWithCustomToken,
  onAuthStateChanged,
  sendPasswordResetEmail,
  firestore,
  doc,
  setDoc,
  getDoc,
  updateDoc,
  storage,
  ref,
  getDownloadURL
};

